<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :types="['com_name', 'field_name', 'date']"
      :mobile-types="['field_name']"
      :typeslabel="{
        com_name: '회사명',
      }"
    />

    <!--    위험성평가 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('위험성평가 정보') }}</h5>
      <div class="writeGridContainer">
        <div>
          <div>{{ $t('평가종류') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_1 }}</p>
          <ml-input v-else v-model="form.inputA_1" :readonly="board.readonly" type="number" />
        </div>
        <div>
          <div>{{ $t('평가자') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputA_2 }}</p>
          <ml-input v-else v-model="form.inputA_2" :readonly="board.readonly" type="number" />
        </div>

        <div class="writeGridLineItem">
          <div>{{ $t('공종명') }}</div>
          <span v-if="isPrint" class="print-textarea"> {{ form.inputA_3 }} </span>
          <ml-input v-else v-model="form.inputA_3" :readonly="board.readonly" />
        </div>
      </div>
    </div>

    <!-- 위험성평가 대상 선정 및 대상 업무에 대한 설명 -->
    <table-custom
      :board="board"
      :is-print="isPrint"
      title="위험성평가 대상 선정 및 대상 업무에 대한 설명"
      :tableData="[
        { id: 'input1', title: '공정 구분', type: 'text' },
        { id: 'input2', title: '세부작업', type: 'text' },
        { id: 'input3', title: '공종설명', type: 'textarea' },
        { id: 'input4', title: '설비/공구', type: 'textarea' },
        { id: 'input5', title: '화학물질', type: 'textarea' },
      ]"
      :mobile="['input1']"
      v-model="form.riskList"
      class="mt-28px"
    />

    <!-- 확인자 -->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i>{{ $t('확인자') }}</h5>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>{{ $t('담당') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>{{ $t('검토') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>{{ $t('승인') }}</div>
          <ml-input v-if="!isPrint" v-model="form.sign3.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign3.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">{{ $t('서명') }}</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign3.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign3.sign" :src="form.sign3.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!--    파일첨부-->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import MeasureStateSelector from "@/components/selector/MeasureStateSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import SignField from "@/components/SignField.vue";
import TableCustom from "@/components/TableCustom.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";

export default {
  components: {
    TimeSelector,
    TableCustom,
    SignField,
    PhotoUploadGridModule,
    FieldSelectModule,
    MeasureStateSelector,
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        inputA_1: "",
        inputA_2: "",
        inputA_3: "",

        riskList: [
          { id: 1, input1: "사다리 사용 작업", input2: "기기 설치작업", input3: "각종 기기, 감지기, 카메라 등 설치 및 점검 작업", input4: "A자형 사다리", input5: "" },
          { id: 2, input1: "사다리 사용 작업", input2: "배선 설치작업", input3: "각종 배선 설치 포설작업 및 선로 점검 작업", input4: "A자형 사다리", input5: "" },
          { id: 3, input1: "수공도구 사용 작업", input2: "배선 설치작업", input3: "기기, 감지기, 카메라 등 고정을 위한 나사못 체결 및 해체, 배선절단, 몰드절단 등", input4: "드라이버, 니퍼, 칼, 절단 가위", input5: "" },
        ],
        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        sign3: {
          name: "",
          sign: "",
        },

        fileList: [],
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
